import { render, staticRenderFns } from "./banniere-pub.vue?vue&type=template&id=86ed495c&scoped=true&"
import script from "./banniere-pub.vue?vue&type=script&lang=ts&"
export * from "./banniere-pub.vue?vue&type=script&lang=ts&"
import style0 from "./banniere-pub.vue?vue&type=style&index=0&id=86ed495c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ed495c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCarousel,VCarouselItem,VDialog,VIcon})
